import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";  // Import Header
import QuizPage from "./components/QuizPage";
import Home from "./components/Home";
import User from "./components/User"; 
import "./App.css";

function App() {
  return (
    <Router>
      <Header /> 
      <div className="App">
        <Routes>
          <Route path="/home" element={<User />} />
          <Route path="/" element={<User />} />
          <Route path="/adminview" element={<Home />} />
          <Route path="/quiz/:slug" element={<QuizPage />} />
          <Route path="/invalid" element={<p>❌ Ungültiger QR-Code oder falsches Gerät.</p>} />
          <Route path="/not-found" element={<p>❓ Frage nicht gefunden.</p>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
